import { createAction, props } from '@ngrx/store';

export const savePrecheckin = createAction(
    '[AUTH] save precheckin',
    props<{ value: any }>(),
);

export const updatePrecheckin = createAction(
    '[AUTH] update precheckin',
    props<{ value: any }>(),
);

export const clearPrecheckin = createAction('[AUTH] clear precheckin');

export const getPrecheckin = createAction('[AUTH] get precheckin');
